enum NEXT_ROUTES {
  ROOT = '/',
  ONBOARDING = '/onboarding',
  PORTFOLIO = '/portfolio',
  DISCOVER = '/discover',
  TRANSACTIONS = '/transactions',
  TRANSACTIONS_DETAILS = '/transactions/[id]',
  SAVINGS_PLANS = '/savings-plans',
  SAVINGS_PLAN_DETAILS = '/savings-plans/[id]',
  ASSET_DETAILS = '/assets/[id]',
  ASSET_DETAILS_LEGACY_ORDER_TYPE = '/assets/[id]/[orderOperation]',
  ERROR_GENERIC = '/error/generic',
  ERROR_SERVER = '/error/server',
  ONBOARDING_SUCCESSFUL = '/onboarding/successful',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
  TAX_DETAILS = '/tax-details',
  LEGAL_DOCUMENTATION = '/legal-documentation',
  REPORTS_AND_STATEMENTS = '/reports-and-statements',
  NOTIFICATION_CENTER = '/notification-center',
  AUTH_TIMEOUT = '/auth/timeout',
  AUTH_EXPIRED = '/auth/expired',
  AUTH_ERROR = '/auth/error',
  AUTH_LOGOUT = '/auth/logout',
  AUTH_SIGNIN = '/auth/signin',
  MY_ASSETS = '/my-assets',
  STAKING = '/staking',
  STAKING_ASSETS = `${STAKING}/assets`,
  STAKING_WEEKLY_REWARDS = `${STAKING}/weekly-rewards`,
  US_PERSON = '/us-person',
  ORDERS = '/orders',
  ORDERS_DETAILS = '/orders/[id]',
  CLIENT_CATEGORIZATION = '/client-categorization',
  CLIENT_CATEGORIZATION_CONFIRM = '/client-categorization/confirm',
  APPROPRIATENESS_QUESTIONS_INTRO = '/appropriateness-questions/introduction',
  APPROPRIATENESS_QUESTIONS_REJECTED = '/appropriateness-questions/rejected',
  APPROPRIATENESS_QUESTIONS_BLOCKED = '/appropriateness-questions/blocked',
}

export { NEXT_ROUTES };
